module.exports = __webpack_public_path__ + "static/media/iflip.c4f57215.svg";